<template>
  <v-autocomplete
    :value="value"
    :disabled="items.length < 1"
    :items="items"
    label="Semester"
    item-text="shortText"
    item-value="id"
    @change="select"
    v-bind="$attrs"
    return-object
  >
  </v-autocomplete>
</template>
<script>
import { defineComponent } from "vue";
export default defineComponent({
  name: "TermInput",
  props: {
    value: null,
    range: null, //  array
  },
  data() {
    return {
      items: [],
    };
  },
  methods: {
    select($event) {
      this.$emit("input", $event);
    },
  },
  async mounted() {
    if (!this.range) {
      this.items = await this.apiList({
        resource: "common/term",
      });
    } else {
      if (Array.isArray(this.range) && this.range.length == 2) {
        this.items = await this.apiList({
          resource: "common/term",
          query: `offsetpast=${this.range[0]}&offsetfuture=${this.range[1]}`,
        });
      }
    }
  },
});
</script>
